/**
 * 플레이어 화면 구현
 */
customElements.define(
  'sbs-player-wide-screen',
  class extends HTMLElement {
    constructor() {
      super();

      const endpageTop = document.querySelector('.endpage-top');
      this.active = endpageTop && endpageTop.classList.contains('screen-mode');
    }

    static get observedAttributes() {
      return [];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
        const endpageTop = document.querySelector('.endpage-top');
        console.log('endpageTop', endpageTop);
        if (endpageTop) {
          this.render();
        }
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        this.innerHTML = `<div class="controlToggle-wideScreen">
					<button type="button" class="BtnToggle-wideScreen ${
            this.active ? 'Btn-normalScreen' : ''
          }" aria-label="넓은화면 모드${
          this.active ? ' 해제' : ''
        }"><!-- Btn-normalScreen : 넓은화면 모드 해제 -->
						<span class="iconSvg_wideScreen">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
								<path d="M19 16.4C19 17.0896 18.754 17.7507 18.3164 18.2383C17.8788 18.7259 17.2855 19 16.6667 19H7.33333C6.7145 19 6.12118 18.7259 5.68359 18.2383C5.24601 17.7507 5 17.0896 5 16.4V8.6C5 7.91044 5.24601 7.24931 5.68359 6.76172C6.12118 6.27413 6.7145 6 7.33333 6H16.6667C17.2855 6 17.8788 6.27412 18.3164 6.76172C18.754 7.24932 19 7.91044 19 8.6V16.4Z" fill="white"></path>
								<path d="M5.96168 0C6.44012 2.07022e-08 6.82757 0.401953 6.82757 0.898296C6.82757 1.39464 6.44012 1.79659 5.96168 1.79659H1.73177V6.18482C1.73177 6.68117 1.34432 7.08312 0.865887 7.08312C0.387451 7.08312 0 6.68117 0 6.18482V0.898296C0 0.401953 0.387451 0 0.865887 0H5.96168Z" fill="white"></path>
								<path d="M18.0383 23.9999C17.5599 23.9999 17.1724 23.598 17.1724 23.1016C17.1724 22.6053 17.5599 22.2033 18.0383 22.2033H22.2682V17.8151C22.2682 17.3188 22.6557 16.9168 23.1341 16.9168C23.6125 16.9168 24 17.3188 24 17.8151V23.1016C24 23.598 23.6125 23.9999 23.1341 23.9999H18.0383Z" fill="white"></path>
							</svg>
							<i class="hide">넓은화면 모드</i>
						</span>
						<span class="iconSvg_normalScreen">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
								<path d="M17 14.7857C17 15.2783 16.8243 15.7505 16.5117 16.0988C16.1992 16.4471 15.7754 16.6429 15.3333 16.6429H8.66667C8.22464 16.6429 7.80084 16.4471 7.48828 16.0988C7.17572 15.7505 7 15.2783 7 14.7857V9.21432C7 8.72178 7.17572 8.24954 7.48828 7.90126C7.80084 7.55298 8.22464 7.35718 8.66667 7.35718H15.3333C15.7754 7.35718 16.1992 7.55298 16.5117 7.90126C16.8243 8.24955 17 8.72178 17 9.21432V14.7857Z" fill="white"></path>
								<path d="M23.1341 16.9166C23.6126 16.9166 24 17.3186 24 17.8149C24 18.3113 23.6125 18.7132 23.1341 18.7132L18.9042 18.7132L18.9042 23.1015C18.9042 23.5978 18.5168 23.9998 18.0383 23.9998C17.5599 23.9998 17.1724 23.5978 17.1724 23.1015L17.1724 17.8149C17.1724 17.3186 17.5599 16.9166 18.0383 16.9166L23.1341 16.9166Z" fill="white"></path>
								<path d="M0.865466 7.08301C0.38703 7.08301 -0.000421012 6.68105 -0.000420969 6.18471C-0.000420925 5.68837 0.38703 5.28641 0.865466 5.28641L5.09537 5.28642L5.09537 0.898186C5.09537 0.401842 5.48283 -0.000110267 5.96126 -0.000110225C6.4397 -0.000110183 6.82715 0.401843 6.82715 0.898186L6.82715 6.18471C6.82715 6.68105 6.4397 7.08301 5.96126 7.08301L0.865466 7.08301Z" fill="white"></path>
							</svg>
							<i class="hide">넓은화면 모드 해제</i>
						</span>
					</button>
				</div>`;
        this.event();
        this.styles();
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      try {
        this.querySelector('button').addEventListener('click', (event) => {
          const endpageTop = document.querySelector('.endpage-top');
          if (endpageTop) {
            endpageTop.classList.toggle('screen-mode');
            this.active = endpageTop.classList.contains('screen-mode');

            const button = this.querySelector('.BtnToggle-wideScreen');
            if (this.active) {
              button.classList.add('Btn-normalScreen');
            } else {
              button.classList.remove('Btn-normalScreen');
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
    styles() {
      try {
      } catch (error) {
        console.log(error);
      }
    }
  }
);
